export default function Hero() {
  return (
    <section
      id="hero"
      style={{
        position: 'relative',
        width: '100%',
        height: '100vh',
        minHeight: '600px',
        overflow: 'hidden',
        background: '#081D34',
      }}
    >
      {/* video background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      >
        <source src="/7513671-hd_1920_1080_24fps.mp4" type="video/mp4" />
      </video>

      {/* dark navy overlay so text reads clearly */}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: 'rgba(8, 29, 52, 0.62)',
      }} />

      {/* text overlay */}
      <div style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        padding: '0 24px',
        textAlign: 'center',
      }}>
        <h1 style={{
          color: '#ffffff',
          fontSize: 'clamp(2.2rem, 5.5vw, 3.8rem)',
          fontWeight: 700,
          lineHeight: 1.12,
          marginBottom: '24px',
          fontFamily: 'Lexend, sans-serif',
          textShadow: '0 2px 32px rgba(8,29,52,0.8)',
          maxWidth: '760px',
        }}>
          Built Fast. Breaks Fast.<br />We Fix That.
        </h1>
        <p style={{
          color: 'rgba(191,214,240,0.9)',
          fontSize: 'clamp(1rem, 2vw, 1.15rem)',
          lineHeight: 1.75,
          marginBottom: '36px',
          fontFamily: 'Lexend, sans-serif',
          fontWeight: 300,
          maxWidth: '540px',
          textShadow: '0 1px 16px rgba(8,29,52,0.7)',
        }}>
          Your code runs deep — and so do the problems.<br />
          We dive in where AI stops and ship production-grade software.
        </p>
        <a
          href="#contact"
          style={{
            display: 'inline-block',
            background: '#1E62A1',
            color: '#fff',
            padding: '14px 36px',
            borderRadius: '6px',
            fontWeight: 600,
            fontSize: '15px',
            letterSpacing: '0.3px',
            textDecoration: 'none',
            fontFamily: 'Lexend, sans-serif',
            pointerEvents: 'all',
            transition: 'background 0.2s',
            boxShadow: '0 2px 20px rgba(8,29,52,0.5)',
          }}
          onMouseEnter={e => { e.target.style.background = '#3E86C8'; }}
          onMouseLeave={e => { e.target.style.background = '#1E62A1'; }}
        >
          Let's Talk
        </a>
      </div>

      {/* scroll indicator */}
      <div style={{
        position: 'absolute',
        bottom: '28px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        pointerEvents: 'none',
      }}>
        <span style={{
          color: 'rgba(124,176,225,0.5)',
          fontSize: '10px',
          fontFamily: 'Lexend, sans-serif',
          letterSpacing: '2px',
        }}>SCROLL</span>
        <div style={{
          width: '1px',
          height: '32px',
          background: 'linear-gradient(to bottom, rgba(62,134,200,0.6), transparent)',
        }} />
      </div>
    </section>
  );
}
